import { Component, Inject } from '@angular/core';
import { APIService } from '../../../api.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Protocolo, Usuario } from '../../../model';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core"
import { FlashMessagesService } from 'angular2-flash-messages';
import { UsuarioPageBody } from '../../../model/api/UsuarioPageBody';
import { MatSelectChange } from '@angular/material';
import { ProtocoloService } from '../protocolo-service';

@Component({
  selector: 'select-responsavel-atendimento-modal',
  templateUrl: './select-responsavel-atendimento.component.html',
  styleUrls: ['./select-responsavel-atendimento.component.css']
})
export class SelectResponsavelAtendimentoComponent {
  public mensagens: any;
  public mensagemEnvio = '';
  public selectStatus: any;
  public statusSelecionado: any;
  public _usuarios;
  public loading = true;
  public usuarioSelecionado: Usuario = null;
  constructor(
    private apiService: APIService,
    private router: Router,
    public dialogRef: MatDialogRef<SelectResponsavelAtendimentoComponent>,
    public translate: TranslateService,
    private protocoloService: ProtocoloService, 
    private flashMessagesService: FlashMessagesService,

    @Inject(MAT_DIALOG_DATA) public protocolo: Protocolo) {
    this.getResponsaveis();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  public getResponsaveis() {
      this._usuarios = [];
      let retorno = this.apiService.getUsuariosPorCategoriaAtendimento(this.protocolo.categoriaServico.id);
      //let retorno = this.apiService.getUsuariosSistema();
      
      retorno.subscribe((result: Array<UsuarioPageBody>) => {
        console.log("Usuarios: ", result);
        result
        .forEach(usuario => {
          this._usuarios.push(usuario);
        });
        this.loading = false;
      });
      return retorno;
    
  }

  get usuarios(): Array<Usuario>{
    return [].concat(this._usuarios);
  }

  selecionarUsuario(event: MatSelectChange) {
    this.usuarioSelecionado = <Usuario>event.value;
  }

  public transferirAtendimento(){
    this.loading = true;
    if(this.usuarioSelecionado){
      this.apiService.updateProtocoloAtendente(this.protocolo.id, this.usuarioSelecionado.id).subscribe(data => {
        this.lancarMensagem(this.translate.instant("protocolos.transferidoSucessoAtendimento"), "alert-success");
        this.protocoloService.selecionarRemoverListagemProtocolo(this.protocolo);
        this.onNoClick();
        this.loading = false;
      },
      error => {
        this.lancarMensagem(this.translate.instant("protocolos.transferidoErroAtendimento"), "alert-danger");
        this.onNoClick();
        this.loading = false;
      });
    } else {
      this.lancarMensagem(this.translate.instant("protocolos.selecioneUmUsuario"), "alert-danger");
      this.loading = false;
    }
  }

  public lancarMensagem(mensagem, tipo) {
    this.flashMessagesService.show(mensagem,{ cssClass: tipo });  
  }
  
}

